import React, { FC } from 'react';
import { css } from '@emotion/core';

import { DOT_RADIUS, circleStrokeWidth } from './constants';

const circleDiameter = DOT_RADIUS * 2;

const textStylesBasic = css({
  fontSize: DOT_RADIUS,
  fontWeight: 800,
  textAnchor: 'middle',
});

type DotCircleProps = {
  dotX: number;
  dotY: number;
  fill: string;
  stroke: string;
  textX: number;
  textY: number;
  textFill: string;
  count: number;
};
const DotCircle: FC<DotCircleProps> = ({
  dotX,
  dotY,
  fill,
  stroke,
  textX,
  textY,
  textFill,
  count,
}) => (
  <g>
    <rect
      x={dotX}
      y={dotY}
      width={circleDiameter - 2}
      height={circleDiameter - 2}
      fill={fill}
      rx={DOT_RADIUS}
      stroke={stroke}
      strokeWidth={circleStrokeWidth}
    />
    <text x={textX} y={textY} fill={textFill} css={[textStylesBasic]}>
      {count}
    </text>
  </g>
);

export default DotCircle;
